import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { GetCurrencyType } from "./prepareExtrasArray";
import prepareFeaturesToClient from "./prepareFeaturesToClient";
import HFormatDate from "@rf-helper/format/format-date";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareBuildingToClient = (
  state: IPropertyDetailsResponse
): IPropertyForm["building"] => {
  const features = prepareFeaturesToClient(state);

  return state.project.buildings.map(building => ({
    id: building.id ? String(building.id) : "",
    name: building.description,
    dateDelivery: building.delivers ? HFormatDate(building.delivers, "form") : null,
    isNew: false,
    isDelete: false,
    unitsQuantity: building.units_quantity ? String(building.units_quantity) : "",
    isCaptured: building.is_captured ? Boolean(building.is_captured) : false,
    units: building.units.map(unit => ({
      id: unit.id ? String(unit.id) : "",
      name: unit.name,
      price: unit.price ? String(unit.price) : "",
      currency: GetCurrencyType(unit.currency_id),
      bedrooms: unit.bedrooms ? String(unit.bedrooms) : "0",
      bathrooms: unit.bathrooms ? String(unit.bathrooms) : "0",
      halfBathrooms: unit.half_bathrooms ? String(unit.half_bathrooms) : "0",
      parkingSpots: unit.parking_spots ? String(unit.parking_spots) : "0",
      levelFloor: unit.floor_level ? String(unit.floor_level) : "0",
      totalFloor: "",
      metersConstruction: unit.sqm_construction
        ? String(unit.sqm_construction)
        : "0",
      metersLand: unit.sqm_land ? String(unit.sqm_land) : "0",
      isNew: false,
      isDelete: false,
      maintenanceFee: state.maintenance_fee ? String(state.maintenance_fee) : "",
      maintenanceCurrency: GetCurrencyType(state.maintenance_currency_id),
      features: features.features ?? [],
      totalCommission: state.total_comission || "",
      commissionGuaranteed: state.guaranteed_comission || "",
      characteristics_frames_property: features.characteristics_frames as any[],
      characteristics_closets_property: features.characteristics_closets as any[],
      characteristics_door_property: features.characteristics_doors as any[],
      characteristics_roof_form_property: features.characteristics_roof as any[],
      characteristics_windows_property: features.characteristics_windows as any[],
      characteristics_cabinets_property: features.characteristics_cabinets as any[],
      characteristics_floors_property: features.characteristics_floors as any[],
      characteristics_type_house_property:
        features.characteristics_type_house as any[],
      characteristics_roof_property: features.characteristics_roof as any[]
    }))
  })) as any[];

  // TODO - Check if this is the correct return type
};
export default prepareBuildingToClient;
